/**
 * Clone this to config.js and set appropriate values
 */
export default {
  paymentcloud: {
    STRATUS_URL: 'https://box4portal.paymentcloudinc.com/',
    MAIN_URL: 'https://box4.paymentcloudinc.com/',
    APPLICATION_URL: 'https://box4.paymentcloudinc.com/',
    PUSHER_KEY: '73febcd7537665911014',
    PUSHER_CLUSTER: 'us2',
    GOOGLE_CAPTCHA: '6LeWXeUcAAAAAKUvn0P9aZwZJL4opHTdGzmWCZbX',
    RESIDUAL_SYSTEM: [272, 1, 2, 1197],
    EMS_ORG_ID: 561,
    PAYCHEX_ORG_ID: 549,
    GOOGLE_API_KEY: 'AIzaSyB3wR6GiPzthJOr1U70ldBJ9kwY1KPLt4s',
  },
};
